
import { typeRefundsFilters } from 'model/dashboardRefunds/dRefundsReducer'
import { typeRequestPagination } from '../system/constants';
import { apiClient } from 'model/axiosConfig';


// Type
export type typeRefundsRequestFilters = {
    filters: {
        date?: {
            from: string,
            to: string,
        } | {},
        userName?: string | string[] | null,
        fmId?: string[] | null
        store?: {id: string} | null
    },
    pageFilter: typeRequestPagination,
    sortFilter: {
        direction: string,
        column: string
    }
}


// Get Refunds list
export const getRefundsList = async (payload: {
    filters: typeRefundsFilters,
    paginationRequest: typeRequestPagination
}) => {

    const path = '/product/refund/v2/search/slim'
    const config = {
        headers: {},
    }

    const data: typeRefundsRequestFilters = {
        filters: {},
        pageFilter: payload.paginationRequest,
        sortFilter: {
            direction: "DESC",
            column: "date"
        }
    }
    if (payload.filters.fmId) data.filters.fmId! =  [ payload.filters.fmId ]

    if (payload.filters.date) {
        data.filters.date! = payload.filters.date
    }
    if (payload.filters.userName) {
        data.filters.userName! = [ payload.filters.userName ]
    }
    if (payload.filters.storeId) {
        data.filters.store! = {id: payload.filters.storeId }
    }

    try {

        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

// Get Refund by Id
export const getRefundById = async (payload: {id: string}) => {

    const path = `/product/refund/${ payload.id }`
    const config = {
        headers: {},
    }
    try {

        return await apiClient.get(path, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

// Get Refunds Details by refund Id
export const getRefundDetailsById = async (payload: { refundId: string }) => {
    const path = `/product/refund/${payload.refundId}/full`;

    const config = {
        headers: {},
    };

    try {
        return await apiClient.get(path, config);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};
